"use client";
import { Stack } from "@mui/material";

import { observer, useStore } from "../../../../service/mobx";
import LabelWithIcon from "../../../../component/LabelWithIcon";
import { TaskSize2 as TaskCard } from "../../../../component/Card/Task";
import { PaperCardSize3 as PaperCard } from "../../../../component/Card/Paper";
import { CardVideoSize2 as VideoCard } from "../../../../component/Card/External/Video";

function Preview({ Icon, label, entityName, capital }) {
  const { search } = useStore();
  const top3Results = search[`suggested${capital}`]?.slice(0, 3) ?? [];
  const cards = {
    paper: PaperCard,
    video: VideoCard,
    tag: TaskCard
  };
  const Card = cards[entityName] ?? (() => null);

  return top3Results.length ? (
    <>
      <LabelWithIcon Icon={Icon} label={label} />
      <Stack spacing={1}>
        {top3Results.map(entity => (
          <Card key={entity.id} {...{ [entityName]: entity }} />
        ))}
      </Stack>
    </>
  ) : null;
}

export default observer(Preview);
